import { useContext } from "react";

import { AuthContext } from "./AuthContext";

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export const useLoginSocial = () => {
  const { loginSocial, loginSocialLoading, loginSocialError } = useAuthContext();
  return [loginSocial, { loading: loginSocialLoading, error: loginSocialError }] as const;
};

export const useLogout = () => {
  const { logout } = useAuthContext();
  return logout;
};

export const useAccessToken = () => {
  const { accessToken } = useAuthContext();
  return accessToken;
};
